const xorEncrypt = (text: string, key: string) => {
	let result = '';
	for (let i = 0; i < text.length; i++) {
		result += String.fromCharCode(
			text.charCodeAt(i) ^ key.charCodeAt(i % key.length)
		);
	}
	return result;
};

export default xorEncrypt;
